export default __webpack_public_path__ + "static/media/ic_i2e.ce573f34.png";